// Auto-generated by scripts/generate-registry.mjs from packages/modules/rattan_cylindrical_pen_holder_type_a/ui-config.json — DO NOT EDIT MANUALLY!
import type { ModuleSchema } from './types.js';

export const rattan_cylindrical_pen_holder_type_a: ModuleSchema = {
  "id": "rattan_cylindrical_pen_holder_type_a",
  "uniqueId": "B3D_RCP01",
  "createdAt": "2026-10-26T16:09:29.312Z",
  "updatedAt": "2026-10-27T08:51:46.738Z",
  "label": "Cylindrical Pen Caddy",
  "description": "Open square pen holder with structural Type A interlocking strands and a 3 mm floor pad.",
  "category": "rattan",
  "tags": [
    "rattan-cylindrical-pen-holder-type-a"
  ],
  "sliders": [
    {
      "key": "width",
      "label": "Cylinder Diameter",
      "min": 45,
      "max": 180,
      "default": 80,
      "step": 1,
      "unit": "mm"
    },
    {
      "key": "depth",
      "label": "Cylinder Diameter",
      "min": 45,
      "max": 180,
      "default": 80,
      "step": 1,
      "unit": "mm",
      "visible": false
    },
    {
      "key": "height",
      "label": "Holder Height",
      "min": 40,
      "max": 180,
      "default": 100,
      "step": 1,
      "unit": "mm"
    },
    {
      "key": "cornerRadius",
      "label": "Corner Radius",
      "min": 1,
      "max": 20,
      "default": 6,
      "step": 0.5,
      "unit": "mm",
      "visible": false
    },
    {
      "key": "wavePitch",
      "label": "Wave Pitch",
      "min": 1.5,
      "max": 18,
      "default": 6,
      "step": 0.5,
      "unit": "mm"
    },
    {
      "key": "waveAmplitude",
      "label": "Wave Amplitude",
      "min": 0,
      "max": 4,
      "default": 1,
      "step": 0.1,
      "unit": "mm"
    },
    {
      "key": "layerOverlap",
      "label": "Structural Layer Overlap",
      "min": 0.1,
      "max": 1.6,
      "default": 0.3,
      "step": 0.05,
      "unit": "mm"
    },
    {
      "key": "strandThickness",
      "label": "Strand Thickness",
      "min": 0.4,
      "max": 4,
      "default": 1,
      "step": 0.1,
      "unit": "mm"
    },
    {
      "key": "strandHeight",
      "label": "Strand Height",
      "min": 0.8,
      "max": 8,
      "default": 2,
      "step": 0.1,
      "unit": "mm"
    },
    {
      "key": "padThickness",
      "label": "Floor Pad Thickness",
      "min": 1,
      "max": 8,
      "default": 2,
      "step": 0.1,
      "unit": "mm"
    }
  ],
  "selects": [
    {
      "key": "padPlacement",
      "label": "Pad Placement",
      "default": "inside",
      "options": [
        {
          "value": "inside",
          "label": "Inside lowest strand"
        },
        {
          "value": "outer",
          "label": "Outer strand boundary"
        }
      ]
    }
  ],
  "textParams": [],
  "colorConfigs": [
    {
      "key": "body",
      "label": "Rattan Body",
      "default": "#D97706",
      "targetGroupIds": [
        0
      ]
    }
  ],
  "objects": [
    {
      "id": "pen_holder",
      "label": "Cylindrical Pen Holder",
      "parts": [
        {
          "id": "woven_body",
          "label": "Type A Woven Body and Floor Pad",
          "groupId": 0,
          "colorKey": "body",
          "defaultColor": "#D97706"
        }
      ]
    }
  ],
  "exportGroups": [
    {
      "id": "all",
      "label": "Download STL - Square Pen Holder"
    }
  ]
};
